import { TnEngineExtraContext, ViewEditor } from "pytha";
import { Group } from "../interface/speccommon/group";
import { Group as ThreeGroup } from "three";

/**
 * 组的context
 */
export class TnGroupContext {
    private static instance: TnGroupContext;

    extraContext: TnEngineExtraContext;
    groups: Group[];
    currentGroupViewObj: ThreeGroup;

    // 私有构造函数
    private constructor() {
        this.extraContext = TnEngineExtraContext.getInstance();
    }

    // 公共方法获取实例
    public static getInstance(): TnGroupContext {
        if (!TnGroupContext.instance) {
            TnGroupContext.instance = new TnGroupContext();
        }
        return TnGroupContext.instance;
    }

    public clearHelpBox(needRedraw: boolean): void {
        if (!this.currentGroupViewObj || !this.currentGroupViewObj.parent) return;
        if (!this.extraContext.getCurrentViewEditor()) return;
        this.extraContext.sceneContext.scene.remove(this.currentGroupViewObj);
        this.currentGroupViewObj = null;
        if (needRedraw) {
            this.extraContext.getCurrentViewEditor().listeners.signals.needRender.dispatch('redraw');
        }
    }

    public drawHelpBox(needRedraw: boolean): void {
        if (!this.currentGroupViewObj) return;
        if (!this.extraContext.getCurrentViewEditor()) return;
        this.extraContext.sceneContext.scene.add(this.currentGroupViewObj);
        if (needRedraw) {
            this.extraContext.getCurrentViewEditor().listeners.signals.needRender.dispatch('redraw');
        }
    }

}